import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";

// audiosprite --e "mp3" --o ../assets/audio/audiosprite *.mp3

export class AudioManager {

    private static game: Phaser.Game;
    private static audioSprite: Phaser.AudioSprite;
    private static loopPlayingKey: string;

    public static init(game: Phaser.Game): void {

        AudioManager.game = game;

        AudioManager.loopPlayingKey = null;

        AudioManager.audioSprite = AudioManager.game.add.audioSprite("audio-sprite");
        
        AudioManager.game.sound.mute = GameVars.gameData.muted;
    }

    public static mute(): void {

        if (AudioManager.game && AudioManager.game.sound) {
            AudioManager.game.sound.mute = true;
        }
    }

    public static unMute(): void {

        if (AudioManager.game && AudioManager.game.sound) {
            AudioManager.game.sound.mute = false;
        }
    }

    public static toggleAudioState(): void {

        GameVars.gameData.muted = !GameVars.gameData.muted;
        GameManager.writeGameData();

        AudioManager.game.sound.mute = GameVars.gameData.muted;
    }

    public static playSound(key: string, loop?: boolean, volume?: number): void {

        loop = loop || false;
       
        if (loop) {

            if (AudioManager.loopPlayingKey && (AudioManager.loopPlayingKey !== key)) {
                AudioManager.stopSound(AudioManager.loopPlayingKey, false, true);
                AudioManager.audioSprite.play(key, volume);
            } else if (!AudioManager.loopPlayingKey) {
                AudioManager.audioSprite.play(key, volume);
            }

            AudioManager.loopPlayingKey = key;

        } else {
            AudioManager.audioSprite.play(key, volume);
        }
    }

    public static changeSoundVolume(key: string, v: number): void {

        const sound = this.audioSprite.get(key);
        sound.volume = v;
    }

    public static stopSound(key: string, fade?: boolean, loop?: boolean): void {

        if (key === null || typeof key === "undefined") {
            return;
        }

        if (fade) {
            let sound: Phaser.Sound = this.audioSprite.get(key);
            sound.fadeOut(850);
        } else {
            AudioManager.audioSprite.stop(key);
        }

        if (loop) {
            AudioManager.loopPlayingKey = null;
        }
    }
}
